/** Утилиты форматирования для UI. */

const _TZ = 'Europe/Moscow';

/** Форматирует число как USDT с фиксированными 2 знаками. */
export function fmtUsd(value: number): string {
  return `$${value.toFixed(2)}`;
}

/** Форматирует процент с знаком. */
export function fmtPct(value: number): string {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
}

/** Форматирует ISO-дату как московское время `HH:MM:SS dd.MM` (Europe/Moscow, UTC+3). */
export function fmtDateTime(iso: string): string {
  const d = new Date(iso);
  const parts = new Intl.DateTimeFormat('ru-RU', {
    timeZone: _TZ,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    day: '2-digit',
    month: '2-digit',
  }).formatToParts(d);
  const get = (type: string): string => parts.find((p) => p.type === type)?.value ?? '00';
  return `${get('hour')}:${get('minute')}:${get('second')} ${get('day')}.${get('month')}`;
}

/** Короткое московское время `HH:MM` (Europe/Moscow, UTC+3). */
export function fmtTime(iso: string): string {
  const d = new Date(iso);
  const parts = new Intl.DateTimeFormat('ru-RU', {
    timeZone: _TZ,
    hour: '2-digit',
    minute: '2-digit',
  }).formatToParts(d);
  const get = (type: string): string => parts.find((p) => p.type === type)?.value ?? '00';
  return `${get('hour')}:${get('minute')}`;
}
